import React from 'react';
import { SypacText } from '@sypac/component-library-react';
import { PinContentProps } from '../Map.interface';
import { cn } from '../../../lib/utils';
import Flag from 'react-world-flags';

const PinContent = ({
	countryCode,
	address,
	orderProduct,
	productStore,
	companyName,
	markerHovered,
}: PinContentProps) => {
	return (
		<div
			className={cn(
				'flex rounded-lg bg-white border border-solid border-gray-10 box-border',
				!orderProduct
					? 'w-fit px-1'
					: markerHovered === orderProduct?.name
					? 'w-[100px] p-[3px] scale-[1.4] shadow-notify'
					: 'w-[82px] p-[2px] shadow-dropdown',
			)}
		>
			<div
				className={cn('flex items-center', companyName && 'flex-col gap-[6px]')}
			>
				{countryCode && !companyName && (
					<Flag
						className="object-cover border border-solid border-gray-10 rounded mr-[6px]"
						code={countryCode}
						width={20}
						height={14}
					/>
				)}

				{companyName && (
					<SypacText variant="body-regular-medium">
						<p className="text-[16px] leading-[22px] text-gray-80">
							{companyName}
						</p>
					</SypacText>
				)}

				{address && (
					<SypacText
						variant="body-regular-medium"
						className={countryCode ? 'ml-3' : ''}
					>
						<p className="max-w-[344px] text-gray-80 truncate mt-[2px]">
							{address}
						</p>
					</SypacText>
				)}

				{orderProduct && (
					<div className="flex flex-col gap-[3px]">
						<div
							style={{
								backgroundImage: `url(${orderProduct.photoUrl})`,
							}}
							className="flex flex-none w-[32px] h-[32px] bg-no-repeat bg-cover rounded-[8px] border border-solid border-gray-10"
							role="img"
						/>

						<div className="flex flex-col gap-[2px]">
							<SypacText variant="body-normal-medium">
								<p
									className={`text-[10px] leading-[14px] text-gray-80 truncate ${
										!orderProduct.type && !orderProduct.size ? 'pb-[14px]' : ''
									} ${
										markerHovered === orderProduct?.name
											? 'w-[94px]'
											: 'w-[76px]'
									}`}
								>
									{orderProduct.name}
								</p>
							</SypacText>
							<SypacText variant="body-normal-medium">
								<p
									className={`text-[8px] leading-[12px] text-gray-40 truncate ${
										markerHovered === orderProduct?.name
											? 'w-[94px]'
											: 'w-[76px]'
									}`}
								>
									{orderProduct.type}{' '}
									{orderProduct.size && `(${orderProduct.size})`}
								</p>
							</SypacText>
						</div>
					</div>
				)}

				{productStore && (
					<div className="flex flex-col gap-1 p-1 whitespace-nowrap">
						<SypacText variant="body-regular-medium">
							<p>{productStore.name}</p>
						</SypacText>

						<SypacText variant="body-regular-medium">
							<p className="text-gray-40">
								Products in store: {productStore.productCount}
							</p>
						</SypacText>
					</div>
				)}
			</div>
		</div>
	);
};

export default PinContent;
